import type { AnnotatablePlace, Place } from '@/types/assistant.js'

export function isAnnotatablePlace(place: Place): place is AnnotatablePlace {
  return place.status === 'active'
}
